import { Box } from '@mui/system'
import WaitingDoctorPane from './WaitingDoctorPane'
import ChimeMeeting from './ChimeMeeting'
import { Consultation } from '@/core/models/consultation.model'

type VisioProps = {
  consultation: Consultation | undefined
  handleJoinMeeting: () => void
}
export function Visio(props: VisioProps) {
  const { consultation, handleJoinMeeting } = props

  return (
    <Box sx={{ height: '100%', width: '100%', display: 'flex', '& > div': { flex: 1 } }}>
      {consultation && !!consultation.waitingRoom && !consultation.medecin ? (
        <WaitingDoctorPane consultationId={consultation._id} waitingRoomId={consultation.waitingRoom} />
      ) : (
        <ChimeMeeting joinMeeting={handleJoinMeeting} inputConsultationId={consultation?._id} />
      )}
    </Box>
  )
}
